import { User } from "./User"

export const authHeader = () => {
	const user: User = JSON.parse(localStorage.getItem("user") || "null")
	if (user && user.access_token) {
		return { Authorization: "Bearer " + user.access_token }
	} else {
		return {}
	}
}
